import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, xcss } from '@atlaskit/primitives';
import React from 'react';
import { ErrorState } from './ErrorState';
import { LoadingSpinner } from './LoadingSpinner';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/**
 *  Separate `Internal` component created for the custom UI, to make it easier to test.
 * `CustomMenu` is passed to react select, and requires additional props that are
 * internally used by react select, so is difficult to test.
 */
export const CustomMenuInternal = _ref => {
  let {
    status,
    children
  } = _ref;
  if (status === 'error') {
    return /*#__PURE__*/_jsx(ErrorState, {});
  }
  if (status === 'loading') {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
const customMenuStyles = xcss({
  fontFamily: 'font.family.brand.body'
});
export const CustomMenu = _ref2 => {
  let {
    innerRef,
    innerProps,
    selectProps: {
      status
    },
    children
  } = _ref2;
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    ref: innerRef
  }, innerProps), {}, {
    children: /*#__PURE__*/_jsx(Box, {
      xcss: customMenuStyles,
      children: /*#__PURE__*/_jsx(CustomMenuInternal, {
        status: status,
        children: children
      })
    })
  }));
};